// @flow

// Libs
import createReducer from 'fc-utils/createReducer'

// Initial State
import initialState from './initialState'

// Controller
import controller from 'fc-ctrl-soil-test-results'

// Export
export default createReducer(initialState, controller.reducers)
